/** Optional broadcast links may target real user-facing app pages only. */
const PAGES = new Set([
  "/", "/home", "/landing", "/compatibility-hub", "/compatibility", "/team",
  "/marriage", "/pricing", "/birth-chart", "/wellness", "/relationship-journal",
  "/family", "/relationship-coach", "/ai-astrologer", "/daily-growth",
  "/improvement-tracker", "/daily-progress", "/ml-validation", "/tarot",
  "/palm-reading", "/ai-avatar", "/cosmic-challenges", "/classroom", "/match",
  "/kundali-match", "/ashtakoot", "/compatibility/birth", "/kundali/result",
  "/kundali", "/guidance", "/muhurat", "/panchang", "/festivals", "/jyotish-tiers",
  "/numerology", "/gemstones", "/daily-horoscope", "/cosmic-science",
  "/cosmic-nutrition", "/profile", "/birth-details", "/onboarding", "/matches",
  "/help", "/astro-learn", "/about", "/privacy", "/terms", "/refund", "/contact",
  "/ai-usage", "/disclaimer", "/notifications", "/marketplace", "/bookings",
  "/astrologer-dashboard", "/astrologer/dashboard", "/become-astrologer",
  "/team-admin", "/blog", "/embed",
]);

export function getNotificationAppLink(link?: string | null): string | null {
  if (!link || !link.startsWith("/") || link.startsWith("//") || /[\\\s]/.test(link)) return null;
  try {
    const url = new URL(link, "https://notification.invalid");
    if (url.origin !== "https://notification.invalid") return null;
    const path = url.pathname.replace(/\/+$/, "") || "/";
    const dynamic = /^\/(?:session\/[^/]+(?:\/rate)?|astrologer\/[^/]+|match\/shared\/[^/]+|notifications\/[^/]+|astrology\/[^/]+(?:\/[^/]+)?|compatibility\/[^/]+\/[^/]+|astrologer-in\/[^/]+(?:\/[^/]+)?)$/;
    return PAGES.has(path) || dynamic.test(path) ? `${path}${url.search}${url.hash}` : null;
  } catch {
    return null;
  }
}

export function getNotificationDestination(n: { id: string; type: string; link?: string | null }): string {
  // Always read broadcasts first, including old ones with missing/broken links.
  if (n.type === "promo") return `/notifications/${encodeURIComponent(n.id)}`;
  return getNotificationAppLink(n.link) ?? `/notifications/${encodeURIComponent(n.id)}`;
}
